import {
  Calendar,
  MessageSquare,
  Mic,
  Paperclip,
  Video,
  Megaphone,
  Trophy,
  Flame,
  Star,
  StickyNote,
  Search,
  Users,
  BarChart3,
  Repeat,
  Check,
  X,
  Circle,
  Bell,
  Network,
  Smartphone,
  Sparkles,
  ArrowRight,
} from "lucide-react";

/* Shared card wrapper with tilt + violet aura */
const Card = ({ children, className = "" }) => (
  <div
    className={
      "relative overflow-hidden rounded-2xl border border-zinc-200 bg-white p-4 shadow-xl shadow-violet-500/10 " +
      className
    }
  >
    {children}
  </div>
);

/* ────────────────────────────────
   01 · TASKS (Kanban + recurring row)
   ──────────────────────────────── */
export function TasksMockup() {
  const cols = [
    {
      title: "Yapılacak",
      dot: "bg-zinc-300",
      cards: [
        { t: "Landing hero'yu bitir", p: "med" },
        { t: "Recurring test scriptleri", p: "high", r: true },
      ],
    },
    {
      title: "Devam ediyor",
      dot: "bg-violet-500",
      cards: [
        { t: "Motivasyon rozet grid'i", p: "urg" },
        { t: "Kanal RSVP akışı", p: "med" },
      ],
    },
    {
      title: "Tamamlandı",
      dot: "bg-emerald-500",
      cards: [{ t: "Onboarding wizard", p: "low", done: true }],
    },
  ];
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="text-sm font-semibold text-zinc-900">Website Redesign</div>
          <span className="rounded-full bg-violet-100 px-2 py-0.5 text-[10px] font-semibold text-violet-700">
            12 açık
          </span>
        </div>
        <div className="flex items-center gap-1 text-[11px] text-zinc-500">
          <Calendar className="h-3.5 w-3.5" /> 4 Şub
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {cols.map((c) => (
          <div key={c.title} className="rounded-xl bg-zinc-50/60 p-2">
            <div className="mb-2 flex items-center gap-1.5">
              <span className={"h-2 w-2 rounded-full " + c.dot} />
              <span className="text-[11px] font-semibold text-zinc-700">{c.title}</span>
            </div>
            <div className="space-y-1.5">
              {c.cards.map((card, i) => (
                <div
                  key={i}
                  className="rounded-lg border border-zinc-200 bg-white p-2 text-[11px]"
                >
                  <div className="flex items-center gap-1.5">
                    <Circle className={"h-3 w-3 " + (card.done ? "fill-emerald-500 text-emerald-500" : "text-zinc-300")} />
                    <span
                      className={
                        "line-clamp-1 flex-1 " +
                        (card.done ? "text-zinc-400 line-through" : "text-zinc-800")
                      }
                    >
                      {card.t}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center gap-1">
                    <Prio p={card.p} />
                    {card.r && (
                      <span className="inline-flex items-center gap-0.5 rounded-full bg-violet-100 px-1.5 py-0.5 text-[9px] font-semibold text-violet-700">
                        <Repeat className="h-2.5 w-2.5" /> Haftalık
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}

function Prio({ p }) {
  const map = {
    urg: ["bg-red-100 text-red-700", "Acil"],
    high: ["bg-amber-100 text-amber-700", "Yüksek"],
    med: ["bg-sky-100 text-sky-700", "Orta"],
    low: ["bg-zinc-100 text-zinc-500", "Düşük"],
  };
  const [cls, lbl] = map[p] || map.low;
  return (
    <span className={"rounded-full px-1.5 py-0.5 text-[9px] font-semibold " + cls}>
      {lbl}
    </span>
  );
}

/* ────────────────────────────────
   02 · CHAT (channel + bubbles + voice + video)
   ──────────────────────────────── */
export function ChatMockup() {
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between border-b border-zinc-100 pb-2">
        <div className="flex items-center gap-2">
          <span className="font-mono text-zinc-400">#</span>
          <div className="text-sm font-semibold text-zinc-900">website</div>
          <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
            6 üye
          </span>
        </div>
        <button className="flex items-center gap-1 rounded-full bg-emerald-500 px-2.5 py-1 text-[11px] font-semibold text-white">
          <Video className="h-3 w-3" /> Görüşme başlat
        </button>
      </div>
      <div className="space-y-3">
        <ChatMsg
          initials="MD"
          color="bg-sky-100 text-sky-700"
          name="Mehmet Demir"
          time="14:22"
          body="Toplantı 15:00'te. Herkes @elif @zeynep ekibiyle hazır olsun."
          reactions={[["👍", 3], ["🚀", 1]]}
        />
        <ChatMsg
          initials="EK"
          color="bg-violet-100 text-violet-700"
          name="Elif Kaya"
          time="14:24"
          body={
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-1 text-[11px] font-semibold text-emerald-700">
              <Video className="h-3 w-3" /> 📹 Görüşmeye katıl
            </span>
          }
        />
        <ChatMsg
          initials="ZÇ"
          color="bg-pink-100 text-pink-700"
          name="Zeynep Çelik"
          time="14:25"
          voice
        />
        <div className="mt-2 rounded-xl border border-zinc-200 bg-zinc-50/60 p-2">
          <div className="flex items-center gap-1.5 text-[11px] text-zinc-400">
            <Paperclip className="h-3 w-3" />
            <Mic className="h-3 w-3" />
            <span className="ml-1">Mesaj yaz…</span>
          </div>
        </div>
      </div>
    </Card>
  );
}

function ChatMsg({ initials, color, name, time, body, reactions, voice }) {
  return (
    <div className="flex items-start gap-2.5">
      <div
        className={
          "flex h-8 w-8 flex-none items-center justify-center rounded-full text-[10px] font-bold " +
          color
        }
      >
        {initials}
      </div>
      <div className="flex-1">
        <div className="flex items-baseline gap-2">
          <span className="text-[12px] font-semibold text-zinc-900">{name}</span>
          <span className="text-[10px] text-zinc-400">{time}</span>
        </div>
        {voice ? (
          <div className="mt-1 flex items-center gap-2 rounded-2xl border border-zinc-200 bg-white p-2 pl-3">
            <button className="flex h-6 w-6 items-center justify-center rounded-full bg-violet-500 text-white">
              ▶
            </button>
            <div className="flex flex-1 items-center gap-0.5">
              {[3, 5, 7, 6, 8, 4, 6, 9, 7, 5, 3, 6, 8, 6].map((h, i) => (
                <span
                  key={i}
                  className="w-0.5 rounded-full bg-violet-400"
                  style={{ height: `${h * 2}px` }}
                />
              ))}
            </div>
            <span className="text-[10px] text-zinc-400">0:14</span>
          </div>
        ) : (
          <div className="mt-1 rounded-2xl bg-zinc-100 px-3 py-2 text-[12px] text-zinc-800">
            {body}
          </div>
        )}
        {reactions && (
          <div className="mt-1 flex items-center gap-1">
            {reactions.map(([e, n]) => (
              <span
                key={e}
                className="inline-flex items-center gap-1 rounded-full border border-zinc-200 bg-white px-1.5 py-0.5 text-[10px] text-zinc-600"
              >
                <span>{e}</span>
                <span className="font-semibold">{n}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ────────────────────────────────
   03 · ANNOUNCEMENTS (pinned + RSVP)
   ──────────────────────────────── */
export function AnnouncementsMockup() {
  return (
    <Card>
      <div className="mb-3 flex items-center gap-2 rounded-xl border border-amber-200 bg-gradient-to-r from-amber-50 to-amber-100/70 px-3 py-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-500/20 text-amber-700">
          <Megaphone className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-amber-700">
            Sabit duyuru · 3 gün kaldı
          </div>
          <div className="text-sm font-semibold text-zinc-900">
            Cuma 15:00 — Q1 Roadmap Toplantısı
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-zinc-200 p-3">
        <div className="mb-2 flex items-center justify-between">
          <div className="flex items-center gap-2 text-[11px]">
            <Video className="h-3.5 w-3.5 text-emerald-600" />
            <span className="font-semibold text-zinc-800">Online — Jitsi</span>
            <span className="text-zinc-400">· 60 dk</span>
          </div>
          <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
            LCV Açık
          </span>
        </div>
        <div className="mb-2 text-[11px] text-zinc-600">
          Kabul edenler için otomatik görev oluşturulur.
        </div>
        <div className="flex items-center gap-1.5">
          <button className="flex items-center gap-1 rounded-full bg-emerald-500 px-2.5 py-1 text-[11px] font-semibold text-white">
            <Check className="h-3 w-3" /> Evet · 4
          </button>
          <button className="flex items-center gap-1 rounded-full bg-amber-500 px-2.5 py-1 text-[11px] font-semibold text-white">
            ? Belki · 1
          </button>
          <button className="flex items-center gap-1 rounded-full bg-zinc-200 px-2.5 py-1 text-[11px] font-semibold text-zinc-700">
            <X className="h-3 w-3" /> Hayır · 0
          </button>
        </div>
        <div className="mt-3 flex -space-x-1.5">
          {["EK", "MD", "ZÇ", "AY"].map((i, k) => (
            <div
              key={k}
              className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-violet-100 text-[9px] font-bold text-violet-700"
            >
              {i}
            </div>
          ))}
          <div className="flex h-6 items-center justify-center rounded-full border-2 border-white bg-zinc-100 px-1.5 text-[9px] font-semibold text-zinc-500">
            +2
          </div>
        </div>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   04 · MOTIVATION (XP + leaderboard)
   ──────────────────────────────── */
export function MotivationMockup() {
  const board = [
    { n: "Elif Kaya", xp: 1840, lvl: 8, i: "EK", c: "bg-pink-100 text-pink-700", m: true },
    { n: "Mehmet Demir", xp: 1620, lvl: 7, i: "MD", c: "bg-sky-100 text-sky-700" },
    { n: "Zeynep Çelik", xp: 1290, lvl: 6, i: "ZÇ", c: "bg-violet-100 text-violet-700" },
  ];
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between">
        <div className="text-sm font-semibold text-zinc-900">Motivasyon</div>
        <div className="flex items-center gap-1 rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-semibold text-orange-700">
          <Flame className="h-3 w-3" /> 12 gün seri
        </div>
      </div>

      <div className="mb-3 rounded-xl bg-gradient-to-br from-violet-500 to-pink-500 p-3 text-white">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/20">
            <Trophy className="h-4 w-4" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-wider opacity-80">Seviye 7</div>
            <div className="text-lg font-bold">1,240 XP</div>
          </div>
          <div className="ml-auto text-right">
            <div className="text-[10px] uppercase tracking-wider opacity-80">Sıradaki</div>
            <div className="text-sm font-semibold">1,500</div>
          </div>
        </div>
        <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-white/25">
          <div className="h-full w-3/4 rounded-full bg-white" />
        </div>
      </div>

      <div className="space-y-1.5">
        {board.map((r, i) => (
          <div
            key={r.n}
            className={
              "flex items-center gap-2 rounded-xl px-2.5 py-1.5 " +
              (r.m ? "bg-violet-50 ring-1 ring-inset ring-violet-200" : "bg-white")
            }
          >
            <span className="w-4 text-center text-[10px] font-bold text-zinc-500">
              #{i + 1}
            </span>
            <div
              className={
                "flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-bold " +
                r.c
              }
            >
              {r.i}
            </div>
            <span className="flex-1 text-[12px] font-semibold text-zinc-800">
              {r.n}
            </span>
            <span className="text-[10px] font-semibold text-violet-700">
              Lv {r.lvl}
            </span>
            <span className="text-[11px] font-bold text-zinc-900">{r.xp}</span>
          </div>
        ))}
      </div>

      <div className="mt-3 flex items-center gap-1.5">
        {[
          { i: Star, c: "bg-amber-100 text-amber-600" },
          { i: Flame, c: "bg-orange-100 text-orange-600" },
          { i: Trophy, c: "bg-violet-100 text-violet-600" },
        ].map(({ i: I, c }, idx) => (
          <div
            key={idx}
            className={
              "flex h-8 w-8 items-center justify-center rounded-xl " + c
            }
          >
            <I className="h-4 w-4" />
          </div>
        ))}
        <span className="text-[10px] font-semibold text-zinc-500">+11 rozet</span>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   05 · PERSONAL (Notes + Calendar + Me/Everyone)
   ──────────────────────────────── */
export function PersonalMockup() {
  return (
    <Card>
      <div className="mb-3 flex items-center gap-2">
        <div className="flex rounded-full bg-zinc-100 p-0.5 text-[11px] font-semibold">
          <span className="rounded-full bg-white px-2.5 py-1 text-zinc-900 shadow-sm">
            Ben
          </span>
          <span className="px-2.5 py-1 text-zinc-500">Herkes</span>
        </div>
        <span className="ml-auto text-[11px] text-zinc-400">Şu an</span>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {/* Quick Notes */}
        <div className="rounded-xl border border-zinc-200 bg-white p-3">
          <div className="mb-2 flex items-center gap-1.5">
            <StickyNote className="h-3.5 w-3.5 text-amber-500" />
            <span className="text-[11px] font-semibold text-zinc-800">Hızlı Notlar</span>
          </div>
          <div className="space-y-1.5">
            {[
              { t: "Trafik raporunu incele", done: true },
              { t: "Elif ile PR review", done: false },
              { t: "Kahve al ☕", done: false },
            ].map((n, i) => (
              <div key={i} className="flex items-center gap-1.5 text-[11px]">
                <span
                  className={
                    "flex h-3.5 w-3.5 items-center justify-center rounded border " +
                    (n.done
                      ? "border-violet-500 bg-violet-500 text-white"
                      : "border-zinc-300 bg-white")
                  }
                >
                  {n.done && <Check className="h-2.5 w-2.5" strokeWidth={3} />}
                </span>
                <span className={n.done ? "text-zinc-400 line-through" : "text-zinc-700"}>
                  {n.t}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Calendar */}
        <div className="rounded-xl border border-zinc-200 bg-white p-3">
          <div className="mb-2 flex items-center gap-1.5">
            <Calendar className="h-3.5 w-3.5 text-sky-500" />
            <span className="text-[11px] font-semibold text-zinc-800">Bu hafta</span>
          </div>
          <div className="grid grid-cols-7 gap-0.5 text-center text-[9px] text-zinc-400">
            {["P", "S", "Ç", "P", "C", "C", "P"].map((d, i) => (
              <span key={i}>{d}</span>
            ))}
          </div>
          <div className="mt-1 grid grid-cols-7 gap-0.5 text-center">
            {[3, 4, 5, 6, 7, 8, 9].map((d) => (
              <div
                key={d}
                className={
                  "rounded-md py-1 text-[10px] " +
                  (d === 6
                    ? "bg-violet-500 font-semibold text-white"
                    : "text-zinc-700")
                }
              >
                {d}
              </div>
            ))}
          </div>
          <div className="mt-2 space-y-1">
            <div className="rounded-md bg-violet-50 px-1.5 py-1 text-[10px] font-semibold text-violet-700">
              10:00 Kanban review
            </div>
            <div className="rounded-md bg-pink-50 px-1.5 py-1 text-[10px] font-semibold text-pink-700">
              15:00 Q1 toplantısı
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   06 · PLATFORM (search + MRR/tenants)
   ──────────────────────────────── */
export function PlatformMockup() {
  return (
    <Card>
      <div className="mb-3 flex items-center gap-2 rounded-full border border-zinc-200 bg-zinc-50 px-3 py-2">
        <Search className="h-3.5 w-3.5 text-zinc-400" />
        <span className="flex-1 text-[11px] text-zinc-600">&quot;cuma toplantısı&quot;</span>
        <kbd className="rounded border border-zinc-200 bg-white px-1.5 py-0.5 text-[9px] font-semibold text-zinc-500">
          ⌘K
        </kbd>
      </div>

      <div className="mb-3 space-y-1">
        {[
          { c: "text-violet-600", t: "Görev · Cuma 15:00 Roadmap" },
          { c: "text-sky-600", t: "Kanal mesajı · # website" },
          { c: "text-emerald-600", t: "Kişi · Elif Kaya" },
        ].map((r, i) => (
          <div
            key={i}
            className="flex items-center gap-2 rounded-lg border border-zinc-100 bg-white px-2 py-1.5"
          >
            <span className={"text-[10px] font-bold uppercase " + r.c}>#</span>
            <span className="text-[11px] text-zinc-700">{r.t}</span>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-zinc-200 bg-gradient-to-br from-zinc-50 to-white p-3">
        <div className="mb-2 flex items-center gap-2 text-[11px] font-semibold text-zinc-700">
          <BarChart3 className="h-3.5 w-3.5 text-violet-500" />
          Platform · MRR & Churn
        </div>
        <div className="grid grid-cols-3 gap-2 text-center">
          <div>
            <div className="text-[9px] uppercase text-zinc-400">MRR</div>
            <div className="text-sm font-bold text-zinc-900">$4.8k</div>
          </div>
          <div>
            <div className="text-[9px] uppercase text-zinc-400">Aktif</div>
            <div className="text-sm font-bold text-zinc-900">243</div>
          </div>
          <div>
            <div className="text-[9px] uppercase text-zinc-400">Churn</div>
            <div className="text-sm font-bold text-emerald-600">1.2%</div>
          </div>
        </div>
        <div className="mt-2 flex items-end gap-0.5">
          {[40, 55, 45, 62, 68, 74, 82, 78, 88].map((h, i) => (
            <div
              key={i}
              className="flex-1 rounded-t bg-gradient-to-t from-violet-400 to-violet-600"
              style={{ height: `${h * 0.45}px` }}
            />
          ))}
        </div>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   07 · PUSH NOTIFICATIONS (iOS-lockscreen bubble + preference toggles)
   ──────────────────────────────── */
export function PushMockup() {
  const bubbles = [
    {
      app: "Serpix",
      time: "şimdi",
      title: "Elif Kaya",
      body: "Toplantı 14:00'te başlıyor — herkese görev düşecek 🚀",
    },
    {
      app: "Serpix",
      time: "3 dk",
      title: "Yeni görev: Website Redesign",
      body: "Sana atandı · Yarın teslim · Yüksek öncelik",
    },
  ];
  const prefs = [
    { label: "Görev", on: true },
    { label: "DM", on: true },
    { label: "Mention", on: true },
    { label: "Fatura", on: false },
  ];
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between text-[10px] font-medium text-zinc-400">
        <span className="flex items-center gap-1.5">
          <Bell className="h-3 w-3 text-violet-600" />
          Bildirimler
        </span>
        <span className="rounded-full bg-emerald-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-emerald-700">
          Aktif
        </span>
      </div>
      {/* iOS-style stacked notification bubbles */}
      <div className="space-y-1.5">
        {bubbles.map((b, i) => (
          <div
            key={i}
            className="rounded-xl border border-zinc-200 bg-white/80 p-2.5 shadow-sm backdrop-blur"
          >
            <div className="mb-1 flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <span className="inline-flex h-3.5 w-3.5 items-center justify-center rounded-[4px] bg-violet-600 text-[7px] font-bold text-white">
                  S
                </span>
                <span className="text-[9px] font-semibold uppercase tracking-wide text-zinc-500">
                  {b.app}
                </span>
              </div>
              <span className="text-[9px] text-zinc-400">{b.time}</span>
            </div>
            <div className="text-[10px] font-semibold text-zinc-900">{b.title}</div>
            <div className="line-clamp-2 text-[10px] text-zinc-600">{b.body}</div>
          </div>
        ))}
      </div>
      {/* Per-event pref toggles */}
      <div className="mt-3 rounded-lg border border-zinc-100 bg-zinc-50/70 p-2">
        <div className="mb-1.5 text-[9px] font-semibold uppercase tracking-wide text-zinc-500">
          Tercihler
        </div>
        <div className="grid grid-cols-2 gap-1.5">
          {prefs.map((p) => (
            <div
              key={p.label}
              className="flex items-center justify-between rounded bg-white px-2 py-1 text-[10px]"
            >
              <span className="text-zinc-700">{p.label}</span>
              <span
                className={
                  p.on
                    ? "inline-flex h-3 w-6 items-center justify-end rounded-full bg-violet-600 pr-0.5"
                    : "inline-flex h-3 w-6 items-center justify-start rounded-full bg-zinc-300 pl-0.5"
                }
              >
                <span className="h-2.5 w-2.5 rounded-full bg-white" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   08 · ORG CHART (avatar nodes + tree lines)
   ──────────────────────────────── */
function OrgNode({ n }) {
  return (
    <div className="flex flex-col items-center">
      <div
        className={`flex h-9 w-9 items-center justify-center rounded-full ${n.tint} text-[10px] font-bold text-white shadow-sm ring-2 ring-white`}
      >
        {n.name}
      </div>
      <span className="mt-1 text-[9px] font-medium text-zinc-600">
        {n.label}
      </span>
    </div>
  );
}

export function OrgChartMockup() {
  const nodes = {
    ceo: { name: "MB", tint: "bg-violet-500", label: "CEO" },
    cto: { name: "AC", tint: "bg-sky-500", label: "CTO" },
    cmo: { name: "EK", tint: "bg-pink-500", label: "CMO" },
    dev1: { name: "OK", tint: "bg-amber-500", label: "Lead" },
    dev2: { name: "SD", tint: "bg-indigo-500", label: "Dev" },
    mkt1: { name: "ZY", tint: "bg-emerald-500", label: "Design" },
  };
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between text-[10px] font-medium text-zinc-400">
        <span className="flex items-center gap-1.5">
          <Network className="h-3 w-3 text-violet-600" />
          Serpix HQ
        </span>
        <div className="flex items-center gap-1">
          <span className="rounded bg-violet-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-violet-700">
            Aktif
          </span>
          <span className="rounded bg-zinc-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-zinc-500">
            Dev
          </span>
          <span className="rounded bg-zinc-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-zinc-500">
            +
          </span>
        </div>
      </div>
      <div className="relative">
        {/* CEO — center top */}
        <div className="mb-4 flex justify-center">
          <OrgNode n={nodes.ceo} />
        </div>
        {/* Connector lines */}
        <div className="relative mx-auto mb-3 h-4 w-[70%]">
          <div className="absolute left-1/2 top-0 h-2 w-px bg-zinc-300" />
          <div className="absolute left-[15%] right-[15%] top-2 h-px bg-zinc-300" />
          <div className="absolute left-[15%] top-2 h-2 w-px bg-zinc-300" />
          <div className="absolute right-[15%] top-2 h-2 w-px bg-zinc-300" />
        </div>
        {/* CTO + CMO */}
        <div className="mb-4 flex justify-around px-2">
          <OrgNode n={nodes.cto} />
          <OrgNode n={nodes.cmo} />
        </div>
        {/* Second-level connector */}
        <div className="relative mx-auto mb-3 h-3 w-[70%]">
          <div className="absolute left-[15%] top-0 h-full w-px bg-zinc-200" />
          <div className="absolute left-[calc(15%+8px)] right-[calc(50%+4px)] top-2 h-px bg-zinc-200" />
          <div className="absolute right-[15%] top-0 h-full w-px bg-zinc-200" />
        </div>
        {/* Leaf nodes */}
        <div className="flex justify-between px-4">
          <OrgNode n={nodes.dev1} />
          <OrgNode n={nodes.dev2} />
          <OrgNode n={nodes.mkt1} />
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between border-t border-zinc-100 pt-2 text-[9px] text-zinc-500">
        <span>6 kişi · 2 seviye</span>
        <span className="flex items-center gap-1 font-medium text-violet-600">
          <ArrowRight className="h-2.5 w-2.5" />
          PDF olarak indir
        </span>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   09 · ONBOARDING (5-step progress + step preview)
   ──────────────────────────────── */
export function OnboardingMockup() {
  const currentStep = 2; // showing step 3 of 5 (0-indexed)
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between text-[10px] font-medium text-zinc-400">
        <span className="flex items-center gap-1.5">
          <Sparkles className="h-3 w-3 text-violet-600" />
          Hoşgeldin — Elif
        </span>
        <span className="text-[9px] text-zinc-500">3 / 5</span>
      </div>
      {/* Progress dots */}
      <div className="mb-4 flex items-center justify-center gap-1.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className={`h-1.5 rounded-full transition ${
              i === currentStep
                ? "w-7 bg-violet-600"
                : i < currentStep
                  ? "w-4 bg-violet-300"
                  : "w-4 bg-zinc-200"
            }`}
          />
        ))}
      </div>
      {/* Step 3 preview — first-task form */}
      <div className="mb-3">
        <div className="mb-1 text-[13px] font-bold text-zinc-900">
          İlk görevini oluştur
        </div>
        <div className="text-[10px] leading-relaxed text-zinc-500">
          Yaparak öğrenmek en hızlısı. Küçük bir görev at, dashboard&apos;da gör.
        </div>
      </div>
      <div className="space-y-2">
        <div>
          <div className="mb-1 text-[9px] font-medium text-zinc-500">Başlık</div>
          <div className="rounded-md border border-zinc-200 bg-white px-2 py-1.5 text-[10px] text-zinc-800">
            Serpix&apos;i keşfet
          </div>
        </div>
        <div>
          <div className="mb-1 text-[9px] font-medium text-zinc-500">Teslim</div>
          <div className="flex items-center justify-between rounded-md border border-zinc-200 bg-white px-2 py-1.5 text-[10px] text-zinc-800">
            <span>2 gün sonra</span>
            <span className="text-zinc-400">▾</span>
          </div>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className="text-[9px] text-zinc-400">← Geri</span>
        <div className="rounded-md bg-violet-600 px-2.5 py-1 text-[10px] font-semibold text-white">
          Görev oluştur →
        </div>
      </div>
    </Card>
  );
}

/* ────────────────────────────────
   10 · MOBILE (iPhone-frame with task cards)
   ──────────────────────────────── */
export function MobileMockup() {
  const cards = [
    { title: "Website redesign", tag: "yüksek", tint: "bg-rose-100 text-rose-700" },
    { title: "Faturaları gözden geçir", tag: "orta", tint: "bg-amber-100 text-amber-700" },
    { title: "Ekip retro'su", tag: "düşük", tint: "bg-emerald-100 text-emerald-700" },
  ];
  return (
    <Card className="!p-6">
      <div className="mb-3 flex items-center justify-between text-[10px] font-medium text-zinc-400">
        <span className="flex items-center gap-1.5">
          <Smartphone className="h-3 w-3 text-violet-600" />
          Mobil görünüm
        </span>
        <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-emerald-700">
          PWA
        </span>
      </div>
      {/* iPhone-esque frame */}
      <div className="mx-auto max-w-[200px] rounded-[26px] border-[6px] border-zinc-900 bg-white shadow-inner">
        {/* Notch */}
        <div className="relative flex justify-center py-1">
          <div className="h-1 w-12 rounded-full bg-zinc-800" />
        </div>
        {/* Screen content */}
        <div className="px-2 pb-2">
          <div className="mb-2 flex items-center justify-between">
            <div className="text-[10px] font-bold text-zinc-900">Görevlerim</div>
            <div className="rounded-full bg-zinc-100 p-0.5">
              <Search className="h-2.5 w-2.5 text-zinc-500" />
            </div>
          </div>
          {/* Cards stack */}
          <div className="space-y-1.5">
            {cards.map((c, i) => (
              <div
                key={i}
                className="rounded-lg border border-zinc-200 bg-white p-2"
              >
                <div className="mb-1 flex items-center justify-between">
                  <span className="line-clamp-1 text-[9px] font-semibold text-zinc-800">
                    {c.title}
                  </span>
                  <span
                    className={`shrink-0 rounded px-1 py-0.5 text-[7px] font-bold uppercase ${c.tint}`}
                  >
                    {c.tag}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="h-1 flex-1 rounded-full bg-zinc-100">
                    <span
                      className="block h-full rounded-full bg-violet-500"
                      style={{ width: `${30 + i * 20}%` }}
                    />
                  </span>
                  <span className="text-[8px] text-zinc-400">
                    {30 + i * 20}%
                  </span>
                </div>
              </div>
            ))}
          </div>
          {/* Bottom nav */}
          <div className="mt-2 flex items-center justify-around border-t border-zinc-100 pt-1.5 text-[8px] text-zinc-400">
            <span className="font-bold text-violet-600">Görev</span>
            <span>Sohbet</span>
            <span>Profil</span>
          </div>
        </div>
      </div>
    </Card>
  );
}
